/**
 * PublicLayout — shell for public-facing pages.
 *
 * Composes the sticky Header, a main content area with an
 * Outlet for routed pages, and the global Footer. Every
 * public route inherits this layout automatically.
 *
 * Supports smooth scrolling, scroll restoration, and
 * reduced motion preferences.
 */

import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from '@/components/layout';
import { Footer } from '@/components/layout';

export function PublicLayout(): JSX.Element {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:rounded-md focus:bg-primary-700 focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-primary-foreground"
      >
        Skip to content
      </a>
      <Header />
      <main id="main-content" className="flex-1" tabIndex={-1}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
